import React from 'react';
import {RoutePermittedRole} from '../../shared/constants/AppEnums';
import SymbolProvider from '../../services/symbols/SymbolProvider';
import QuotesProvider from '../../services/quotes/QuotesProvider';
import WatchlistProvider from '../../services/watchlist/WatchlistProvider';
import ConditionsProvider from '../../services/conditions/ConditionsProvider';
import EventProvider from '../../services/events/EventProvider';
import ConditionProvider from '../../services/condition/ConditionProvider';
import SettingProvider from '../../services/settings/SettingProvider';
import QuoteProvider from '../../services/quote/QuoteProvider';
import QuotePage from './Quotes/QuotePage';

const Symbols = React.lazy(() => import('./Symbols'));
const Quotes = React.lazy(() => import('./Quotes'));
const Watchlist = React.lazy(() => import('./Watchlist'));
const WatchlistSymbol = React.lazy(() => import('./WatchlistSymbol'));
const Conditions = React.lazy(() => import('./Conditions'));
const ConditionPage = React.lazy(() => import('./Conditions/ConditionPage'));
const Events = React.lazy(() => import('./Events'));
const Settings = React.lazy(() => import('./Settings'));
const Downloads = React.lazy(() => import('./Downloads'));
// const UserVerification = React.lazy(() => import("../auth/UserVerification"));

export const samplePagesConfigs = [
  {
    permittedRole: RoutePermittedRole.user,
    path: '/symbols',
    element: (
      <SymbolProvider>
        <Symbols />
      </SymbolProvider>
    ),
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/quotes',
    element: (
      <QuotesProvider>
        <Quotes />
      </QuotesProvider>
    ),
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/watchlist',
    element: (
      <WatchlistProvider>
        <Watchlist />
      </WatchlistProvider>
    ),
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/watchlist-symbol',
    element: (
      <WatchlistProvider>
        <WatchlistSymbol />
      </WatchlistProvider>
    ),
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/conditions',
    element: (
      <ConditionsProvider>
        <Conditions />
      </ConditionsProvider>
    ),
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/events',
    element: (
      <EventProvider>
        <Events />
      </EventProvider>
    ),
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/conditions/:conditionId',
    element: (
      <ConditionProvider>
        <ConditionPage />
      </ConditionProvider>
    ),
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/quotes/:quoteId',
    element: (
      <QuoteProvider>
        <QuotePage />
      </QuoteProvider>
    ),
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/settings',
    element: (
      <SettingProvider>
        <Settings />
      </SettingProvider>
    ),
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/downloads',
    element: <Downloads />,
  },
  // {
  //   permittedRole: RoutePermittedRole.user,
  //   path: '/verification/:verificationCode',
  //   element: <UserVerification />,
  //   exact: true,
  // },
  // {
  //   permittedRole: RoutePermittedRole.user,
  //   path: '/dashboard/settings',
  //   element: <Settings />,
  // },
];
